import checktreeRepository from './repositories/checktree';
import matrixRepository from './repositories/matrix';
import reportsRepository from './repositories/reports';

export const ws = {
  checktree: checktreeRepository,
  matrix: matrixRepository,
  reports: reportsRepository,
};
